module.exports = __webpack_public_path__ + "static/media/joslazet.b5dd5780.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/joslazet.webp
// module id = 284
// module chunks = 0